import type { Route } from 'nextjs-routes';

const TEMPLATE_MAP: Record<Route['pathname'], string> = {
  '/': 'Amplify vaults - optimize yield farming on Sei blockchain',
  '/vaults': 'Vaults',
  '/vaults/[id]': 'Vault %id%',
  '/press-kit': 'Press Kit',
  '/404': '404',
  '/api/deposit/verify/[address]': 'Deposit verification',
  '/t-debug': 'Debug',
  '/directional-vaults': 'Directional Vaults',
  '/directional-vaults/positions': 'Directional Vaults - Positions',
  '/directional-vaults/automator': 'Directional Vaults - Automator',
  '/test-bridge': 'Test Bridge',
  '/api/deposit/tokens': 'Deposit Tokens',
  '/api/proxy/drv/[...path]': 'DRV API',
  '/api/tokens': 'Tokens',
  '/sass-example': 'SASS Example',
  '/sofa-example': 'SOFA Example',
  '/wormhole': 'Wormhole',
  '/api/wormhole': 'Wormhole API',
};

export function make(pathname: Route['pathname']) {
  const template = TEMPLATE_MAP[pathname] ?? TEMPLATE_MAP['/'];
  return `${template}`;
}
